import { observer } from 'mobx-react';

import type { FormProps } from '../EditEntryDataForm';

import { translate } from '@chaika/i18n/helper';

import { DatePicker } from '@components/datePickers';
import { Button } from '@components/Button';

import { useDateForm } from '../hooks/forms/useDateForm';

import { EntryDataDataTest } from '../data-test';

interface Props extends FormProps {}

export const DateForm = observer(({ entry }: Props): React.ReactElement<any> => {
    const { creationTime, visitTime, canSave, canEdit, onTimeChange, onSave } = useDateForm({ entry });

    return (
        <>
            <DatePicker
                disabled
                dataTest={EntryDataDataTest.CreationDateSelect}
                title={translate('creationDate')}
                value={creationTime}
                onChange={() => {}}
            />
            <DatePicker
                disabled={!canEdit}
                dataTest={EntryDataDataTest.VisitDateSelect}
                title={translate('visitDate')}
                value={visitTime}
                onChange={onTimeChange}
            />
            <div>
                <Button
                    dataTest={EntryDataDataTest.DateSave}
                    disabled={!canSave}
                    label={translate('save')}
                    onClick={onSave}
                />
            </div>
        </>
    );
});
